var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './countrySelect.module.scss';
import FlagSelect from './flagSelect';
export default class CountrySelect extends PureComponent {
    onSelect(item) {
        const { countries, onSelect } = this.props;
        const country = countries.find(({ country_code }) => country_code === item.id);
        if (!country) {
            return;
        }
        onSelect(country);
    }
    searchNumbers() {
        const { setShowTabs, selectedCountry: country, phoneSearch: { getItems }, } = this.props;
        if (!country) {
            return;
        }
        getItems({ country }, ['national', 'geographic']);
        setShowTabs(true);
    }
    getCountryItems() {
        const { countries } = this.props;
        return countries.map(({ country, country_code, country_prefix }) => ({
            id: country_code,
            flag: country_code,
            name: `${country.toLowerCase()} (+${country_prefix})`,
        }));
    }
    renderPrefix() {
        var _a;
        const { selectedCountry } = this.props;
        const country = (_a = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.country_code) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        return (_jsx("div", Object.assign({ className: styles.selectPrefix }, { children: _jsx("span", { className: classnames('flag', country) }) })));
    }
    render() {
        const { selectedCountry } = this.props;
        const selectedCountryCode = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.country_code;
        return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("div", Object.assign({ className: styles.rootSelect }, { children: [_jsx("label", Object.assign({ htmlFor: "countryCode", className: styles.rootSelectLabel }, { children: "Country" })), _jsx(FlagSelect, { selectedItem: selectedCountryCode, items: this.getCountryItems(), onSelect: this.onSelect })] })), _jsx(Button, Object.assign({ type: "button", className: styles.rootSearch, onClick: this.searchNumbers }, { children: "Search" }))] })));
    }
}
__decorate([
    boundMethod
], CountrySelect.prototype, "onSelect", null);
__decorate([
    boundMethod
], CountrySelect.prototype, "searchNumbers", null);
